export const MODULE_NAME = 'companies';
